"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeContent = void 0;
const common_1 = require("@finley-technologies/common");
const getNodeContent = (formulaNode) => {
    const nodeType = formulaNode.type;
    switch (nodeType) {
        case 'binary-expression':
            return formulaNode.operator;
        case 'cell':
            return formulaNode.key;
        case 'cell-range':
            throw new Error('Cell range content is not available.');
        case 'function':
            return formulaNode.name;
        case 'logical':
            return String(formulaNode.value);
        case 'number':
            return String(formulaNode.value);
        case 'text':
            return formulaNode.value;
        case 'unary-expression':
            return formulaNode.operator;
        default:
            return (0, common_1.finleyAssertUnreachable)(nodeType);
    }
};
exports.getNodeContent = getNodeContent;
//# sourceMappingURL=formulaNode.js.map